import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

// TODO deprecated?
export const Index = { auth: authRoles.producer, routes: [{ path: '/production-payout-producer', component: FuseLoadable({ loader: () => import('./ProductionAndPayoutApp') }) }] };

export default [Index];
